import React from 'react';
import NavBar from "../navigationBar"
import NumberInput from "../components/numberInput"
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import MobileNavBar from '../mobileNavigationBar';


function Help() {
    return (
        <>
            <BrowserView><NavBar /></BrowserView>
            
            <h1>Help ME</h1>
            <MobileView><MobileNavBar /></MobileView>
        </>

    );
}

export default Help;